(() => {
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function initialize(root = document) {
    root.querySelectorAll('[data-gs-product-story]').forEach(story => {
      if (story.dataset.gsReady) return;
      story.dataset.gsReady = 'true';
      story.classList.add('gs-product-story--ready');
      story.querySelectorAll('[data-gs-zoom]').forEach(button => {
        button.addEventListener('click', () => {
          const original = button.querySelector('img');
          if (!original) return;
          const dialog = document.createElement('dialog');
          dialog.className = 'gs-product-lightbox';
          dialog.setAttribute('aria-label', 'Product feature image');
          const close = document.createElement('button');
          close.type = 'button';
          close.className = 'gs-product-lightbox__close';
          close.setAttribute('aria-label', 'Close enlarged image');
          close.textContent = '×';
          const viewport = document.createElement('div');
          viewport.className = 'gs-product-lightbox__viewport';
          const picture = document.createElement('img');
          picture.src = original.currentSrc || original.src;
          picture.alt = original.alt;
          picture.style.setProperty('--gs-image-width', `${original.naturalWidth || original.width}px`);
          viewport.append(picture);
          dialog.append(close, viewport);
          document.body.append(dialog);
          const restoreOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          const cleanup = () => {
            document.documentElement.style.overflow = restoreOverflow;
            dialog.remove();
            button.focus({ preventScroll: true });
          };
          dialog.addEventListener('close', cleanup, { once: true });
          close.addEventListener('click', () => dialog.close());
          dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
          dialog.showModal();
        });
      });
      story.querySelectorAll('[data-gs-carousel]').forEach(carousel => {
        const track = carousel.querySelector('.gs-product-carousel__track');
        const slides = Array.from(track.children);
        const dots = Array.from(carousel.querySelectorAll('[data-gs-index]'));
        const previous = carousel.querySelector('[data-gs-prev]');
        const next = carousel.querySelector('[data-gs-next]');
        if (slides.length < 2) return;
        let index = 0;
        const update = () => {
          index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / Math.max(1, track.clientWidth))));
          dots.forEach((dot, i) => i === index ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current'));
          if (previous) previous.disabled = index === 0;
          if (next) next.disabled = index === slides.length - 1;
        };
        const go = to => {
          const target = Math.max(0, Math.min(slides.length - 1, to));
          track.scrollTo({ left: track.clientWidth * target, behavior: reducedMotion() ? 'auto' : 'smooth' });
        };
        previous?.addEventListener('click', () => go(index - 1));
        next?.addEventListener('click', () => go(index + 1));
        dots.forEach(dot => dot.addEventListener('click', () => go(Number(dot.dataset.gsIndex))));
        track.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            go(index + (event.key === 'ArrowRight' ? 1 : -1));
          }
        });
        let scheduled = false;
        track.addEventListener('scroll', () => {
          if (scheduled) return;
          scheduled = true;
          requestAnimationFrame(() => { update(); scheduled = false; });
        }, { passive: true });
        update();
      });
      story.querySelectorAll('[data-gs-video]').forEach(video => {
        video.querySelector('button')?.addEventListener('click', () => {
          const id = video.dataset.videoId;
          if (!/^[A-Za-z0-9_-]{11}$/.test(id || '')) return;
          const iframe = document.createElement('iframe');
          iframe.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
          iframe.title = 'Grownsy product demonstration';
          iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen';
          iframe.allowFullscreen = true;
          iframe.referrerPolicy = 'strict-origin-when-cross-origin';
          video.replaceChildren(iframe);
        }, { once: true });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
